import { provideAida } from '@adaptiva/ai/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminPortalModule } from './admin-portal.module';
import { AppComponent } from './app.component';
import { getAppRoutes, HostingModule } from './builds';

/**
 * @author Jesse Rogers <jesse.rogers@adaptiva.com>
 * @description Feature module set for Adaptiva-hosted server instances.
 * 	This module contains the base Admin Portal features +
 * 	[`HostingModule`](./builds/hosting/hosting.module.ts),
 * 	which exposes additional features for internal Adaptiva staff.
 * @see HostingModule
 */
@NgModule({
	imports: [
		AdminPortalModule,
		HostingModule,
		RouterModule.forRoot(
			getAppRoutes(
				{
					path: 'operations-manager',
					loadChildren: () => import('@adaptiva/operations-manager').then(m => m.OperationsManagerModule)
				},
				{
					path: 'metadata',
					loadChildren: () => import('@adaptiva/metadata/views').then(m => m.MetadataModule)
				},
				{
					path: 'cloud',
					loadChildren: () => import('@adaptiva/cloud-portal/views').then(m => m.CloudPortalModule),
				},
			)
		),
	],
	declarations: [AppComponent],
	exports: [
		AppComponent,
		RouterModule
	],
	providers: [
		provideAida({
			oemCompatibility: [],
		}),
	]
})
export class BuildModule {

}
